import React from 'react'
import "./about.css";
import Abouts from "../../assests/avatar-2.svg";
import cv from "../../assests/CV.pdf"
const About = () => {
  return (
    <section className="about container section" id="about">
        <h2 className="section__title">About Me</h2>

        <div className="about__container grid">
          <img src={Abouts} alt="" className='about__img'/>

          <div className="about__data grid">
            <div className="about__info">
              <p className="about__description">
                I am Nikhil Kumar from samastipur, Bihar(India). 
                I am currently in final year of my graduation and pursuing my degree in Computer Science from Sant Longowal Institute of Engineering and Technology, 
                Sangrur(Punjab). I had done Diploma from Same college. I loves to do competitive programming.
                and also good at web development.
              </p>
              <a href={cv} download='resume' className="btn">Download CV</a>
            </div>

            <div className="about__skills grid">
              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skill__name">C++</h3>
                  <span className="skills__number">80%</span>
                </div>

                <div className="skills__bar">
                  <span className="skills__percentage c"></span>
                </div>
              </div>

              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skill__name">Python</h3>
                  <span className="skills__numbers">60%</span>
                </div>

                <div className="skills__bar">
                  <span className="skills__percentage python"></span>
                </div>
              </div>

              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skill__name">Java</h3>
                  <span className="skills__numbers">50%</span>
                </div>

                <div className="skills__bar">
                  <span className="skills__percentage java"></span>
                </div>
              </div>

              <div className="skills__data">
                <div className="skills__titles">
                  <h3 className="skill__name">Data Structure</h3>
                  <span className="skills__numbers">60%</span>
                </div>

                <div className="skills__bar">
                  <span className="skills__percentage structure"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>
  )
}

export default About